import React, { Component } from 'react';

import Banner from './Banner';
import Content from './Content';
import Footer from '../Index/Footer';

class Extension extends Component {
    constructor (props) {
        super (props);
        this.scrollIni();
    }

    scrollIni = () => {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }
    
    render() {
        return(
            <div style={{paddingLeft:0, paddingRight: 0,}}>
                <Banner/>
                <Content/>
                <Footer/>
            </div>
        );
    }
}
 
export default Extension;


// WEBPACK FOOTER //
// ./src/site/Componentes/Extension/Extension.jsx